import { Row } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

export const DetailsSection: FC = () => {
  const { t } = useTranslation('donor.RoutineTest.DetailsSection');

  return <Row className={styles.detailsSection}>{t('text')}</Row>;
};
